import { EntityReference } from 'buzz_lib_models';

type CasedIdentifier = { id: string } | { Id: string };
type CasedName = { name: string } | { Name: string };

type CasedNamedEntity = CasedIdentifier & CasedName;

export const toEntityReference = <TValue extends CasedNamedEntity>(value: TValue): EntityReference => {
  const Id = 'id' in value ? value.id : value.Id;
  const Name = 'name' in value ? value.name : value.Name;

  return { Id, Name };
};
